import { render, staticRenderFns } from "./ti6.vue?vue&type=template&id=1d0beafc&scoped=true&"
import script from "./ti6.vue?vue&type=script&lang=js&"
export * from "./ti6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0beafc",
  null
  
)

export default component.exports